import { useState } from 'react';
import { LoginFailure, LoginRequestStart, LoginSuccess } from 'store/AuthenticationSlice';
import { useAppDispatch, useAppSelector } from 'store/Store';
import AuthService from 'service/apicataleg/api/common/AuthService';
import { setClient } from 'store/ClientsSlice';

const useApiAuth = () => {
  const dispatch = useAppDispatch();
  const { isAuthenticated, isFetching } = useAppSelector((state) => state.auth);
  const [loginError, setLoginError] = useState(false);

  const doLogin = (username: string, password: string) => {
    setLoginError(false);
    dispatch(LoginRequestStart(null));
    AuthService.login({ username, password })
      .then((loginResponse) => {
        const { success, response, message } = loginResponse;
        if (success) {
          if (!response) {
            const msg = 'Missing login payload';
            console.error(msg);
            dispatch(LoginFailure(msg));
            setLoginError(true);
            return;
          }

          if (response.role === 'client') {
            const { client, adreces, cistelles, marques } = response.payload;
            dispatch(setClient({ client, carts: cistelles, addresses: adreces, marques }));
          }
          const { accessToken, username: usr, name, empre, role, codi, refreshToken } = response;
          dispatch(
            LoginSuccess({ username: usr, accessToken, name, empre, role, codi, refreshToken }),
          );
        } else {
          const msg = message || '';
          dispatch(LoginFailure(msg));

          setLoginError(true);
        }
      })
      .catch((error) => {
        const { message } = error;
        dispatch(LoginFailure(message));
        setLoginError(true);
      });
  };
  return { doLogin, isAuthenticated, loginError, isFetching };
};

export default useApiAuth;
